import PropTypes from 'prop-types'
import React from 'react'

import { Text } from 'styles/components/typography'

import {
  PaymentSeparateWrapper,
  SeparateLine,
  SeparateLineText,
} from './styles'

const PaymentSeparator = ({ children, texts, isBefore }) => (
  <PaymentSeparateWrapper>
    {isBefore && children}
    <SeparateLine isBefore={isBefore}>
      <SeparateLineText>{texts.payment.or}</SeparateLineText>
    </SeparateLine>
    {isBefore && (
      <Text dangerouslySetInnerHTML={{ __html: texts.payment.choose }} />
    )}
    {!isBefore && children}
  </PaymentSeparateWrapper>
)

PaymentSeparator.propTypes = {
  children: PropTypes.node.isRequired,
  texts: PropTypes.object.isRequired,
  isBefore: PropTypes.bool.isRequired,
}

PaymentSeparator.defaultProps = {
  isBefore: false,
}

export default PaymentSeparator
